// src/pages/Login.tsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Layout, Row, Col, Form, Typography, Input, Button, Card, Divider } from 'antd';
import AppFooter from '../AppFooter/AppFooter';
import logo from '../../assets/images/favicon.png';
import fullLogo from '../../assets/images/logo-no-background.png';
import { useAuth } from '../../auth/AuthContext';
import LinkedInLogin from './LinkedInLogin/LinkedInLogin';
import GoogleLogin from './GoogleLogin/GoogleLogin';
import MicrosoftLogin from './MicrosoftLogin/MicrosoftLogin';

const { Content } = Layout;
const { Title } = Typography;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the dashboard if the user is already logged in
    if (auth.user) {
      navigate('/synopsis');
    }
  }, [auth.user, navigate]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const newUser = await auth.login(username, password);      
      await auth.fetchUserDetails(newUser.access_token);
      setLoading(false);
      // const firstLogin = newUser.first_login;
      // if (firstLogin) navigate('/change-password');
      if (newUser["2fa_flag"]) {
          localStorage.setItem('userEmail', newUser["email"]);
          localStorage.setItem('userPassword', password);
          localStorage.setItem('userName', username);
          navigate('/twoFactorAuthentication')
          
      } else {
        localStorage.setItem('user', JSON.stringify(newUser));
        navigate('/synopsis');
        auth.setUser(newUser);
      } 
    } catch (error) {
      console.error('Login failed:', error);
      setLoading(false);
    }
  };

  return (
    <Layout 
      style={{ 
        minHeight: '100vh', 
        background: "linear-gradient(207deg, rgba(110,168,255,1) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,1) 80%, rgba(110,168,255,1) 100%)",
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Content style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Row>
          <Col xs={24} style={{textAlign: "left", padding: "20px 5%"}}>
            <img 
              src={fullLogo} 
              alt="Sporo Logo" 
              style={{ 
                width: '150px', 
                maxWidth: '40%', 
                minWidth: '120px' 
              }} 
            />
          </Col>
        </Row>
        
        <Row justify="center" align="middle" style={{ flex: 1 }}>
          <Col xs={22} sm={20} md={16} lg={12} xl={8} xxl={6}>
            <div style={{ maxWidth: '100%', margin: '0 auto' }}>
              <Title 
                style={{ 
                  marginTop: '20px', 
                  color: '#146ef5',
                  fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                  textAlign: 'center' 
                }} 
                level={2}
              >
                Welcome to Sporo AI Scribe
              </Title>
              
              <Card 
                style={{ 
                  padding: '5%', 
                  border: "none", 
                  // boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  borderRadius: '8px',
                  margin: '20px 0'
                }}
              >
                <Form 
                  style={{ textAlign: 'left' }} 
                  layout="vertical" 
                  onFinish={handleSubmit}
                  size="large"
                >
                  <Form.Item
                    label="Username or Email Address"
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your username!',
                      },
                    ]}
                  >
                    <Input placeholder="Username or Email Address" value={username} onChange={(e) => setUsername(e.target.value)} />
                  </Form.Item>
                  
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Item>
                  
                  <div
                    className="font-semibold text-muted"
                    style={{ textAlign: 'right' }}
                  >
                    <Link to="/forgot-password" className="text-dark font-bold">
                      Forgot Password?
                    </Link>
                  </div>
                  
                  <Form.Item>
                    <Button
                      type="primary"
                      style={{ 
                        width: '100%', 
                        marginTop: '30px',
                        height: '40px',
                        fontSize: '16px'
                      }}
                      htmlType="submit"
                      loading={loading}
                    >
                      SIGN IN
                    </Button>
                  </Form.Item>
                  
                  <p className="font-semibold text-muted" style={{ textAlign: 'center', marginTop: "10px" }}>
                    Don't have an account?{' '}
                    <Link to="/signup" className="text-dark font-bold">
                      Sign Up
                    </Link>
                  </p>
                  
                  <Divider>OR</Divider>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
                    <LinkedInLogin />
                    <MicrosoftLogin />
                    <GoogleLogin />
                  </div>
                </Form>
              </Card>
              
              <p 
                className="font-semibold text-muted" 
                style={{ 
                  textAlign: 'center', 
                  fontSize: "12px", 
                  fontWeight: 500, 
                  padding: '0 5%' 
                }}
              >
                <i>For any assistance, feel free to reach out to us at {' '}
                <Link to="mailto: contact@sporo.health" target="_blank">contact@sporo.health</Link>
                </i>
              </p>
            </div>
          </Col>
        </Row>
      </Content>
      <AppFooter />
    </Layout>
  );
};

export default Login;
